<template>
  <button @click="toggleSidebar"
          class="mobile-navigator-sidebar"
  >
    <app-icon icon="shelf"
              :is-active="isActive"
    />
  </button>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "MobileNavigatorItemSidebar",
  computed: {
    ...mapState('Interface', ['isSidebarOpen']),

    isActive() {
      return this.isSidebarOpen || this.$route.name !== 'home'
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$route.name !== 'home') {
        return this.$emit('before-toggle')
      } else {
        this.$emit('before-toggle')
      }

      if (this.$bp.isMdOrLess && !this.isSidebarOpen) {
        this.closeAllMenus()
      }

      this.setSidebarOpenState(!this.isSidebarOpen)
    },

    ...mapActions('Interface',  ['setSidebarOpenState', 'closeAllMenus'])
  }
}
</script>